import { Component, input, output, viewChild } from '@angular/core';
import { RidDraggable } from '../../rid-draggable/rid-draggable';
import { RidDropZone } from '../../rid-drop-zone/rid-drop-zone';
import { RidKlankCard } from '../../rid-klank-card/rid-klank-card';
import { RidSpacer } from '../../rid-spacer/rid-spacer';

@Component({
  selector: 'rid-word-building-slot',
  imports: [RidDropZone, RidKlankCard, RidSpacer],
  templateUrl: './rid-word-building-slot.html',
  host: { class: 'block' },
})
export class RidWordBuildingSlot {
  longestOption = input.required<string>();
  value = input<string | undefined>(undefined);
  cleared = output<void>();

  private dropZone = viewChild.required(RidDropZone);

  handleMove(draggable: RidDraggable, point: { x: number; y: number }) {
    this.dropZone().handleMove(draggable, point);
  }

  isSnapped(draggable: RidDraggable): boolean {
    return this.dropZone().isSnapped(draggable);
  }

  unsnap(draggable: RidDraggable) {
    this.dropZone().unsnap(draggable);
  }
}
